var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArticle = function SvgIconArticle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.125 7.625a1 1 0 0 0 0 2h9.75a1 1 0 1 0 0-2zM6.125 12a1 1 0 0 1 1-1h9.75a1 1 0 1 1 0 2h-9.75a1 1 0 0 1-1-1M7.125 14.375a1 1 0 1 0 0 2h9.75a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.5A1.75 1.75 0 0 0 2 5.25v13.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18.75V5.25a1.75 1.75 0 0 0-1.75-1.75zm.25 15v-13h16v13z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArticle;